export const aideTitle = "Aide à la vie quotidienne pour personnes autonomes";
export const aideIntro = "Les services proposés s'adressent aux personnes autonomes et concernent exclusivement l'aide à la vie quotidienne et les services de proximité.";

export const aideCategories = [
  {
    title: "1 — Présence, compagnie et lien social",
    items: [
      "Compagnie à domicile : discussion, café, moments partagés",
      "Promenades à pied",
      "Lecture / faire la lecture",
      "Jeux de société, cartes, activités de convivialité",
      "Accompagnement pour une sortie : marché, café, magasins, promenade…",
      "Présence quelques heures auprès d'une personne qui souhaite de la compagnie",
      "Retour à la famille après une visite, avec l'accord de la personne",
      "Présence et compagnie après un deuil ou pendant une période difficile, sans accompagnement thérapeutique"
    ]
  },
  {
    title: "2 — Courses, accompagnements et services du quotidien",
    items: [
      "Faire les courses avec la personne",
      "Faire les courses à sa place et les apporter à domicile",
      "Effectuer une petite course urgente ou imprévue",
      "Accompagner la personne à ses rendez-vous : médecin, coiffeur, opticien, banque, etc.",
      "Accompagner la personne dans ses démarches extérieures : mairie, administrations, etc.",
      "Accompagner la personne pour choisir ou acheter quelque chose dont elle a besoin",
      "Aller chercher une ordonnance ou des médicaments déjà préparés à la pharmacie",
      "Aller à La Poste : déposer ou récupérer du courrier, un recommandé ou un colis",
      "Récupérer un colis ou une commande",
      "Déposer ou récupérer des vêtements au pressing, chez le cordonnier, pour des retouches ou dans d'autres commerces de proximité",
      "Aider à prendre un rendez-vous : médecin, coiffeur, garage, artisan, etc.",
      "Rechercher et contacter un professionnel lorsque la personne en a besoin : plombier, électricien, jardinier, coiffeur à domicile, etc.",
      "Être présente au domicile lors du passage d'un artisan, d'un technicien ou d'un livreur",
      "Aider à préparer la maison avant la venue de la famille ou de proches",
      "Aider à l'organisation pratique d'un petit événement personnel : anniversaire, repas familial, réception de proches, etc.",
      "Aider à préparer une valise avant un séjour",
      "Aider à ranger les affaires au retour",
      "Déplacements réalisés avec mon véhicule dans le cadre des accompagnements"
    ]
  },
  {
    title: "3 — Aide administrative et numérique",
    items: [
      "Classement et organisation des papiers",
      "Aide pour comprendre une facture ou un courrier",
      "Aide pour remplir des documents simples",
      "Rédaction de courriers simples",
      "Prise de rendez-vous sur Internet",
      "Aide avec smartphone, ordinateur, mails, impressions et démarches numériques simples"
    ]
  },
  {
    title: "4 — Maison et quotidien à domicile",
    items: [
      "Entretien courant / ménage",
      "Rangement et organisation simple du domicile",
      "Changement du linge de lit",
      "Lessive, étendage et pliage du linge",
      "Repassage léger",
      "Vaisselle",
      "Préparation de repas simples",
      "Préparation d'un repas avec la personne, si elle souhaite participer",
      "Aide pour ranger les courses",
      "Sortir et rentrer les poubelles",
      "Arroser les plantes",
      "Réceptionner une livraison",
      "Petites tâches saisonnières simples",
      "Petites tâches pratiques du quotidien",
      "Changer une ampoule accessible",
      "Déplacer ou ranger de petits objets",
      "Préparer le domicile avant le retour de la personne après une absence : aérer, remettre en ordre, faire les courses nécessaires et préparer le nécessaire pour son arrivée",
      "Préparation pratique du domicile avant un retour d'hospitalisation, sans soins ni prise en charge médicale"
    ]
  },
  {
    title: "5 — Animaux de compagnie",
    items: [
      "Nourrir l'animal",
      "Remettre de l'eau fraîche",
      "Promener le chien (selon son gabarit)",
      "Nettoyer/changer la litière du chat",
      "Acheter ou récupérer nourriture et fournitures pour l'animal",
      "Accompagner l'animal chez le vétérinaire",
      "Aller chercher une commande ou un traitement préparé chez le vétérinaire",
      "Aider la personne à s'occuper de son animal lorsque certaines tâches deviennent difficiles",
      "Présence et compagnie auprès de l'animal lorsque nécessaire"
    ]
  }
];

export const aideCustomText = "Votre besoin n'apparaît pas dans cette liste ? N'hésitez pas à me contacter. Chaque situation peut être étudiée individuellement.";

export const aideTarifs = {
  title: "Tarifs : Aide à la vie quotidienne",
  items: [
    "Tarif : 30 €/h",
    "Durée minimale d'intervention : 1 heure",
    "Au-delà de la première heure : facturation par tranche de 30 minutes, soit 15 € la demi-heure",
    "Déplacements : inclus dans un rayon de 15 km autour du domicile du client. Au-delà, seuls les kilomètres supplémentaires sont facturés 0,50 €/km",
    "Jours fériés : 45 €/h (+50 %)",
    "Crédit d'impôt de 50 % : (Certaines prestations peuvent ouvrir droit à un crédit d'impôt de 50 %, selon les conditions en vigueur.)"
  ],
  footer: "Prestations proposées du lundi au samedi. Jours fériés : majoration de 50 % sur le tarif habituel. Achats et dépenses : les achats effectués à votre demande sont facturés en supplément, sur justificatif."
};